import { render, staticRenderFns } from "./InsLangSwitch.vue?vue&type=template&id=0edff8ce&scoped=true"
import script from "./InsLangSwitch.vue?vue&type=script&lang=ts"
export * from "./InsLangSwitch.vue?vue&type=script&lang=ts"
import style0 from "./InsLangSwitch.vue?vue&type=style&index=0&id=0edff8ce&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0edff8ce",
  null
  
)

export default component.exports